module.exports = __webpack_public_path__ + "img/Best of neue Welt weiss.0fcc9543.jpg";